import { createFileRoute } from '@tanstack/react-router'

import { TrainingNeedsPage } from '@/features/training-needs'

export const Route = createFileRoute('/_authenticated/training-needs')({
  component: TrainingNeedsPage,
})

